import { TsrctNegotiationCaseStatus } from '@/generated/gql/graphql';

export const isNegotiationCaseEditable = (negotiationCase?: { status: TsrctNegotiationCaseStatus }) =>
  negotiationCase?.status === TsrctNegotiationCaseStatus.INITIALIZED;
